"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var copy_to_clipboard_1 = __importDefault(require("copy-to-clipboard"));
var core_1 = require("@material-ui/core");
var copy_icon_svg_1 = __importDefault(require("@assets/widgets/user/copy-icon.svg"));
var OnClickTooltip_1 = __importDefault(require("./OnClickTooltip"));
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        copyLinkDiv: {
            display: 'flex',
        },
        copyIcon: {
            marginRight: 5,
            width: function (props) { return props.iconSize; },
        },
    });
});
function CopyButton(_a) {
    var iconSize = _a.iconSize, buttonText = _a.buttonText, shortUrl = _a.shortUrl, stopPropagation = _a.stopPropagation, variant = _a.variant;
    var classes = useStyles({ iconSize: iconSize });
    var urlToCopy = "".concat(document.location.protocol, "//").concat(document.location.host, "/").concat(shortUrl);
    return (react_1.default.createElement(OnClickTooltip_1.default, { tooltipText: "Short link copied" },
        react_1.default.createElement(core_1.Button, { onClick: function (e) {
                (0, copy_to_clipboard_1.default)(urlToCopy);
                if (stopPropagation) {
                    e.stopPropagation();
                }
            } },
            react_1.default.createElement("div", { className: classes.copyLinkDiv },
                react_1.default.createElement("img", { className: classes.copyIcon, src: copy_icon_svg_1.default, alt: "Copy short link" }),
                react_1.default.createElement(core_1.Typography, { variant: variant || 'subtitle2' }, buttonText || urlToCopy)))));
}
exports.default = CopyButton;
